/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Warehouse_ExecutionsInputs */

const en_nav_warehouse_executions = /** @type {(inputs: Nav_Warehouse_ExecutionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse executions`)
};

/**
* | output |
* | --- |
* | "Warehouse executions" |
*
* @param {Nav_Warehouse_ExecutionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_warehouse_executions = /** @type {((inputs?: Nav_Warehouse_ExecutionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Warehouse_ExecutionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_warehouse_executions(inputs)
});